module.exports = "<div class=\"score\" *mobxAutorun>\n  <div>\n    <div>X</div>\n    <span>{{game.score.X}}</span>\n  </div>\n  <div>\n    <div>O</div>\n    <span>{{game.score.O}}</span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/tic-tac-toe/score/score.component.html
// module id = ../../../../../src/app/pages/home/mobx-tic-tac/tic-tac-toe/score/score.component.html
// module chunks = main